import { resolve } from "inversify-react";
import * as React from "react";
import { Link } from "react-router-dom";
import ArtsDataService from "../../components/arts/arts.data.service";
import FavouriteButtonProps from "../../components/arts/parts/favourite";
import BlockchainService from "../../services/blockchain.service";
import IdentityService from "../../services/identity.service";
import NumberProviderService from "../../services/number_provider";
import ImageField from "./data-component/data-image";
import RaritySelect from "./data-component/rarity-select";
import { IGalleryItem } from "../../typings";

interface IProps {
    model: IGalleryItem;
    showWarning?: boolean;

    urlPreffix: string;
    showTemplate?: boolean;
}

interface IState {
    own: boolean;
}

export default class ArtPreview extends React.Component<IProps, any> {

    @resolve
    public blockchainService: BlockchainService;

    @resolve
    public identityService: IdentityService;

    @resolve
    public editionService: NumberProviderService;

    @resolve
    public artsDataService: ArtsDataService;

    constructor(props) {
        super(props);
        this.state = {
            own: true,
        };
    }

    public truncate = (value: string, max = 200) => {
        if (!!value && value.length > max) {
            return value.substr(0, max) + "...";
        }
        return value;
    }

    public componentDidMount() {
        this.blockchainService.ownArtToken(this.props.model.blockchain_hash).then((result) => {
            this.setState({own: result});
        });
    }

    public componentWillReceiveProps(nextProps: any) {
        if (nextProps.model.blockchain_hash !== this.props.model.blockchain_hash) {
            this.blockchainService.ownArtToken(this.props.model.blockchain_hash).then((result) => {
                this.setState({own: result});
            });
        }
    }

    public render() {

        const {model} = this.props;
        let url = `/${this.props.urlPreffix}/${model.id}/`;
        const canFavourite = this.identityService.isAuthenticated() && this.identityService.userInfo &&
        this.identityService.userInfo.wallet_address !== model.owner_wallet;
        return (
                    <div className={`art-preview`} key={model.id}>
                        { !model.unconfirmed ?
                            <Link to={url}>
                                <div className={`art-preview-container ${!model.isCopy && model.edition_count > 1 && this.props.showTemplate ? "template" : ""}`}>
                                    {canFavourite
                                    && <FavouriteButtonProps key={model.id + "fav"} id={model.id}/>}
                                    <ImageField className={canFavourite ? "margin" : ""} key={model.id} id={model.image} unconfirmed={model.unconfirmed}/>
                                    <h3>{model.title}</h3>
                                    <p>
                                        {this.truncate(model.description)}
                                    </p>
                                    <div className="rank-container">
                                        <h2 className="rank"><RaritySelect mode="display" value={model.rarity}/></h2>
                                        {/*this.props.urlPreffix === "collection" && <label>{model.public_edition_number + " / " + model.maxNumberOfEditions}</label>*/}
                                    </div>
                                </div>
                            </Link>
                            :
                            <div>
                                <div className={`art-preview-container ${!model.isCopy && model.edition_count > 1 && this.props.showTemplate ? "template" : ""}`}>
                                    {canFavourite
                                    && <FavouriteButtonProps key={model.id + "fav"} id={model.id}/>}
                                    <ImageField className={canFavourite ? "margin" : ""} key={model.id} id={model.image} unconfirmed={model.unconfirmed}/>
                                    <h3>{model.title}</h3>
                                    <p>
                                        {this.truncate(model.description)}
                                    </p>
                                    <p style={{color: "orange"}}> Unconfirmed transaction </p>
                                    <div className="rank-container">
                                        <h2 className="rank"><RaritySelect mode="display" value={model.rarity}/></h2>
                                        {/*this.props.urlPreffix === "collection" && <label>{model.public_edition_number + " / " + model.maxNumberOfEditions}</label>*/}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/art-preview.tsx